export default class PageEditController {
  constructor(ProductPagesDataProvider, $state, $timeout, Upload, API_URL, APPLICATION_URL) {
    "ngInject"
    if ($state.params.tabId)
      this.activeTab = $state.params.tabId;
    else
      this.activeTab = 1;
    this.type = 3
    this.page = {};
    this.page.products = [];
    this.page.main_category = '';
    this.page.category = '';
    this.page.sub_category = '0';
    this.Upload = Upload;
    this.ProductPagesDataProvider = ProductPagesDataProvider;
    this.$state = $state;
    this.$timeout = $timeout;
    this.API_URL = API_URL;
    this.APPLICATION_URL = APPLICATION_URL;
    this.errorShow = 0;
    this.field = 'id';
    this.order_type = 'asc';
    ProductPagesDataProvider.editor();
    let
      vm = this;
    ProductPagesDataProvider.loadCategoriesNoLimit(0).then(function (result) {
      vm.mainCategories = result;
    });
    vm.setProduct();
  }

  setProduct() {
    let
      vm = this;
    vm.ProductPagesDataProvider.getProductPage(vm.$state.params.id, vm.type).then(function (result) {
      vm.page = result;
      vm.page.products = [];
      vm.changeCategory();
      vm.setEditorsData();
      vm.ProductPagesDataProvider.getProductPageProducts(vm.$state.params.id, vm.type).then(function (result) {
        vm.products = result;
      });
    });
  }

  changeProductAssigment(product) {
    product.__loading = true;
    let
      vm = this;
    let
      productData = {id: product.id, assigned: product.assigned, order: product.order_by};
    let
      index = vm.page.products.findIndex(function (el) {
        return (el.id === product.id);
      });
    if (index !== -1) {
      vm.page.products.splice(index, 1);
    }
    vm.page.products.push(productData);
    product.__loading = false;
  }

  setActiveTab(tabToSet) {
    this.activeTab = tabToSet;
    this.getEditorsData();
  }

  changeCategory() {
    let
      vm = this;
    if (vm.page.category_id) {
      vm.ProductPagesDataProvider.loadCategoriesNoLimit(vm.page.category_id).then(function (result) {
        vm.categories = result;
      });
    }
    else {
      vm.categories = {};
    }
  }

  changeProductAssigment(product) {
    product.__loading = true;
    let
      vm = this;
    let
      productData = {id: product.id, assigned: product.assigned, order: product.order_by};
    let
      index = vm.page.products.findIndex(function (el) {
        return (el.id === product.id);
      });
    if (index !== -1) {
      vm.page.products.splice(index, 1);
    }
    vm.page.products.push(productData);
    product.__loading = false;
  }

onvertToSlug(text) {
  return text
    .toString()
    .normalize('NFKD')                // Bryt ner bokstäver med diakritiska tecken
    .replace(/[\u0300-\u036f]/g, '')  // Ta bort diakritiska tecken (accents)
    .toLowerCase()
    .replace(/å/g, 'a')
    .replace(/ä/g, 'a')
    .replace(/ö/g, 'o')
    .replace(/æ/g, 'ae')
    .replace(/ø/g, 'oe')
    .replace(/\u00fc/g, 'ue')
    .replace(/\s+/g, '-')           // Replace spaces with -
    .replace(/[^\w\-]+/g, '')       // Remove all non-word chars
    .replace(/\-\-+/g, '-')         // Replace multiple - with single -
    .replace(/^-+/, '')             // Trim - from start of text
    .replace(/-+$/, '');            // Trim - from end of text
}

  updateData(productForm, redirect) {
    let
      vm = this;
    vm.getEditorsData();
    vm.$timeout(function () {
      if (!productForm.$valid) {
        vm.errorShow = 1;
        vm.$timeout(function () {
          vm.errorShow = 0;
        }, 3000);
        return false;
      }
      if (vm.page.name)
        vm.page.slug = vm.onvertToSlug(vm.page.name);
      if (!vm.page.sub_category)
        vm.page.sub_category = 0;
      if (!vm.page.alt)
        vm.page.alt = vm.page.name;
      if (vm.page.img && vm.page.img.type) {
        vm.updateWithImage(vm.page.img, redirect);
      }
      else {
        vm.ProductPagesDataProvider.updateProductPage(vm.page, vm.type).then(function (result) {
          vm.page = result;
          vm.page.products = [];
          if (redirect == '1')
            vm.$state.go('app.productPagelisting');
          else {
            vm.successShow = 1;
            vm.$timeout(function () {
              vm.successShow = 0;
            }, 3000);
          }
        });
      }
    }, 5);
  }

  updateWithImage(file, redirect) {
    let
      vm = this;
    file.upload = vm.Upload.upload({
      url: vm.API_URL + '/productPage/saveProductPageImage',
      method: 'POST',
      data: {
        filename: new Date().valueOf() + file.name,
        file: file
      }
    });
    file.upload.then(function (response) {
      let img = vm.page.img;
      let data = vm.page;
      data.img = vm.APPLICATION_URL + response.data;
      vm.ProductPagesDataProvider.updateProductPage(data, vm.type).then(function (result) {
        vm.page = result;
        vm.page.products = [];
        vm.page.img = img;
        if (redirect == '1')
          vm.$state.go('app.productPagelisting');
        else {
          vm.successShow = 1;
          vm.$timeout(function () {
            vm.successShow = 0;
          }, 3000);
        }
      })
    }, function (response) {
      if (response.status > 0)
        alert(response.status + ': ' + response.data);
    });
  }

  removeProduct(product) {
    if (confirm("Are you sure to delete!") !== true) {
      return false;
    }
    product.__loading = true;
    let vm = this;
    let id = product.id;
    let apid = product.admin_product_id;
    vm.ProductPagesDataProvider.removeProduct(id, apid).then(function (res) {
      vm.ProductPagesDataProvider.getProductPageProducts(vm.$state.params.id, vm.type).then(function (result) {
        vm.products = result;
        product.__loading = false;
      });
    })
  }

  getEditorsData() {
    this.page.short_text = tinyMCE.get('short_text').getContent();
    this.page.template_text = tinyMCE.get('template_text').getContent();
    this.page.long_text = tinyMCE.get('long_text').getContent();
    this.page.meta_data = tinyMCE.get('meta_data').getContent();
  }

  setEditorsData() {

    tinyMCE.get('short_text').setContent(this.page.short_text);
    tinyMCE.get('template_text').setContent(this.page.template_text);
    tinyMCE.get('long_text').setContent(this.page.long_text);
    tinyMCE.get('meta_data').setContent(this.page.meta_data);
  }
}


// WEBPACK FOOTER //




/** WEBPACK FOOTER **
 ** C:/Users/larss/Documents/signlabs-admin-frontend/client/app/modules/product-page/components/edit/controller.js
 **/